<template>
	<div>
	{{stars}}
	</div>
</template>


<script>
export default {
	props: [
		'star'
	],
	computed: {
		stars() {
			var res;
			console.log(11111);
			switch (Math.round(this.star)) {
				case 0:
					res = '☆☆☆☆☆'
					break
				case 1:
					res = '★☆☆☆☆'
					break
				case 2:
					res = '★★☆☆☆'
					break
				case 3:
					res = '★★★☆☆'
					break
				case 4:
					res = '★★★★☆'
					break
				case 5:
					res = '★★★★★'
					break
				default:
					res = '';
			}
			return res
		},
	 },
	}
</script>
